import PropTypes from 'prop-types';
import { forwardRef } from 'react';
// @mui
import { Box } from '@mui/material';
// configs
import config from '../../config';

// ----------------------------------------------------------------------

const Logo = forwardRef(
    (
        { disabledLink = false, sx, collapsed, toggleCollapse, ...other },
        ref
    ) => {
        // OR using local (public folder)
        // -------------------------------------------------------
        // const logo = (
        //   <Box
        //     component="img"
        //     src="/logo/logo_single.svg" => your path
        //     sx={{ width: 40, height: 40, cursor: 'pointer', ...sx }}
        //   />
        // );

        const LogoSvg = config.logo ? config.logo : null;

        if (!LogoSvg) return null;

        const logo = (
            <Box
                ref={ref}
                component="div"
                sx={{
                    width: 100,
                    height: 100,
                    display: 'inline-flex',
                    ...sx
                }}
                {...other}
            >
                <LogoSvg />
            </Box>
        );
        const minLogo = (
            <Box
                ref={ref}
                component="div"
                sx={{
                    width: 40,
                    height: 40,
                    display: 'inline-flex',
                    ...sx
                }}
                {...other}
            >
                <LogoSvg />
            </Box>
        );

        if (disabledLink) {
            return <>{logo}</>;
        }

        return (
            <Box
                component="div"
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    cursor: 'pointer',
                    ...sx
                }}
                onClick={toggleCollapse}
            >
                {collapsed ? minLogo : logo}
            </Box>
        );
    }
);

Logo.propTypes = {
    sx: PropTypes.object,
    disabledLink: PropTypes.bool
};

export default Logo;
